function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "ldp-368ed6add7deca",
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0 16 h 8 l 16 -16 h -8 z",
  fill: "#d13438"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "translate",
  values: "0 0; 16 0",
  keyTimes: "0;1",
  dur: "0.5s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M 0 16 h 8 l 16 -16 h -8 z",
  fill: "#d13438"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "translate",
  values: "-16 0; 0 0",
  keyTimes: "0;1",
  dur: "0.5s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("path", {
  d: "M 0 16 h 8 l 16 -16 h -8 z",
  fill: "#d13438"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "translate",
  values: "-32 0; -16 0",
  keyTimes: "0;1",
  dur: "0.5s",
  repeatCount: "indefinite"
}))));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%",
  fill: "url(#ldp-368ed6add7deca)"
});

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ldp-stripe",
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.607da9fa.svg";
export { ForwardRef as ReactComponent };